export const parseArray = (value) => {
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "string") {
    return value
      .replace(/[{}"\\]/g, "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .join(", ");
  }
  return "";
};
